import React, { Component } from 'react'
import {
    Box,
    createStyles,
    Theme,
    withStyles,
    WithStyles,
    Paper,
    Grid,
    TablePagination,
    TableBody,
    Typography,
    TableCell,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    FormControl,
    RadioGroup,
    FormControlLabel,
    Radio
} from '@material-ui/core'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet'
import clsx from 'clsx'
import { ANIMATION, TABLES } from '../../../material.theme'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { IPaginator, ISearch } from '../../../store/ducks/root.types'
import { FollowUp } from '../../../store/application/models/followUp/followUp'
import FollowUpLine from './line'


const Style = (theme: Theme) => createStyles({
    ...ANIMATION,
    ...TABLES(theme),
    paper: {
        width: '100%',
        padding: `${theme.spacing(1)}px 0px`
    },
    button: {
        margin: theme.spacing(1),
        borderRadius: "24px"
    },
    filter: {
        padding: theme.spacing(1),
    }

})

export enum PatientFilter {
    RECENT = "recent",
    OLD = "old"
}

interface IProps {
    readonly paginator: IPaginator
    readonly followUps: FollowUp[]
    readonly loading: boolean

    loadFollowUpRequest(patientId: string, paginator?: IPaginator, filter?: ISearch): void
    changeSearch(search?: ISearch): void
}

interface IState {
    readonly filter: string
}

type IJoinProps = WithTranslation & WithStyles<typeof Style, true> & RouteComponentProps<any> & IProps & IState

class FollowUpPageComponent extends Component<IJoinProps, IState> {
    constructor(props:any) {
        super(props)
        this.state = {
            filter: PatientFilter.RECENT,
        }
    }

    public componentDidUpdate(prevProps: Readonly<IJoinProps>, prevState: Readonly<IState>, snapshot?: any): void {
        const {
            match: {
                params: { patientId }
            },
            loadFollowUpRequest,
            paginator
        } = this.props

        const { filter } = this.state
        if (prevState.filter !== filter) {
            loadFollowUpRequest(patientId, paginator, { key: "created_at", value: filter })
        }

    }
    public render() {
        const {
            t,
            classes,
            paginator,
            match: {
                params: { patientId }
            },
            loadFollowUpRequest,
            followUps,
            loading
        } = this.props

        const {
            rows,
            page,
            totalRecords
        } = paginator

        const { filter } = this.state

        return <Box className={classes.fadeIn1}>

            <Helmet>
                <title>
                    {t('NAVIGATION_TAB.FOLLOWUP')}
                </title>
            </Helmet>
            <Grid container={true}>
                <Grid item={true} xs={12} sm={12} >
                    <Paper className={clsx(classes.paper/*, classes.fadeIn2*/)}>
                        <Grid
                            container={true}
                            alignItems="center"
                            justifyContent="flex-end"
                            item={true}
                            xs={12}
                            sm={12}

                        >
                            <Grid item={true} xs={12} sm={3} className={classes.filter}>
                                <Typography>{t('FILTER.TITLE')}:</Typography>
                                <FormControl>
                                    <RadioGroup
                                        row={true}
                                        name="filter_group"
                                        value={filter}
                                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                            this.setState({ filter: (event.target as HTMLInputElement).value })
                                        }} >
                                        {
                                            Object.values(PatientFilter).map((category: string, index: number) =>
                                                <FormControlLabel
                                                    key={index}
                                                    value={category}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            filter: category
                                                        })
                                                    }}
                                                    control={<Radio />}
                                                    label={t(`FILTER.${category.toLocaleUpperCase()}`)}
                                                />

                                            )
                                        }
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid item={true} xs={12} sm={12} >
                            <TableContainer >
                                <Table size="small" >
                                    <TableHead>
                                        <TableRow key={`patient_line_heard`}>
                                            <TableCell
                                                align='center'
                                                className={classes.tableHeader}>
                                                <Typography >
                                                    <b >{t("TABLE.FOLLOWUP.#")}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell
                                                align='center'
                                                className={classes.tableHeader}>
                                                <Typography >
                                                    <b>{t("TABLE.FOLLOWUP.HISTOLOGICAL_TYPE")}</b>
                                                </Typography >
                                            </TableCell>
                                            <TableCell
                                                align='center'
                                                className={classes.tableHeader}>
                                                <Typography >
                                                    <b>{t("TABLE.FOLLOWUP.CASE_TYPE")}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell
                                                align='center'
                                                className={classes.tableHeader}>
                                                <Typography >
                                                    <b>{t("TABLE.FOLLOWUP.PERIOD_FOLLOWUP")}</b>
                                                </Typography>
                                            </TableCell>
                                            <TableCell
                                                align='center'
                                                className={classes.tableHeader}>
                                                <Typography >
                                                    <b>{t("TABLE.FOLLOWUP.SITUATION")}</b>
                                                </Typography>
                                            </TableCell>

                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {
                                            !loading &&
                                            followUps
                                                ?.map((item: FollowUp, index: number) => {
                                                    return <FollowUpLine
                                                        key={`followUp_line_${index}`}
                                                        index={index + (rows * page)}
                                                        followUp={item} />
                                                })
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 20]}
                                component="div"
                                count={totalRecords || 0}// totalRecords
                                rowsPerPage={rows || 0}// rows
                                page={page || 0}// page      
                                onRowsPerPageChange={(e) => {
                                    loadFollowUpRequest(patientId, {
                                        ...paginator,
                                        rows: Number(e.target.value) || 0
                                    },
                                        { key: "created_at", value: filter })
                                }}
                                onPageChange={(e, current_page: number) => {
                                    loadFollowUpRequest(patientId, {
                                        ...paginator,
                                        page: current_page || 0
                                    },
                                        { key: "created_at", value: filter })
                                }}
                            />
                        </Grid>

                    </Paper>
                </Grid>

            </Grid>


        </Box>

    }
}

const FollowUpPageWithTranslation = withTranslation()(FollowUpPageComponent)

const FollowUpPage: any = withStyles<any>(Style, { withTheme: true })(FollowUpPageWithTranslation)

const FollowUpTable: any = withRouter(FollowUpPage)

export default FollowUpTable
